import { theme, liteTheme } from '../theme/ThemeProvider'
export default { theme, liteTheme }
